import { createSelector } from "reselect";
import { RootState } from "../../state";
import { currentUserSelector, currentCompanySelector } from "../../common/selectors";
import {
  CompanyMembershipSection,
  CompanyMembership,
  FeaturedCompanymembership,
  DenormalizedSection,
} from "../reducers/members";

export const companySelector = (state: RootState) => state.companies.common.company;

export const draftCompanySelector = (state: RootState) => state.companies.common.draftCompany!;
export const draftCompanyAvatarSelector = (state: RootState) => state.companies.common.draftCompanyAvatar;
export const draftCompanyBackgroundSelector = (state: RootState) => state.companies.common.draftCompanyBackground;

export const editModeSelector = (state: RootState) => state.companies.common.editMode;

export const editableSelector = createSelector(companySelector, currentCompanySelector, (company, currentCompany) => {
  return company && currentCompany ? currentCompany.id === company.id : false;
});

export const isMemberSelector = createSelector(
  companySelector,
  currentUserSelector,
  (company, currentUser) => (company && currentUser ? currentUser.working_company_ids.includes(company.id) : false)
);

export const companyDescriptionsSelector = (state: RootState) => state.companies.about.descriptions || [];

export const companyMembershipSectionsSelector = (state: RootState) => state.companies.show.companyMembershipSections;

/*
 * members
 */

export const sectionSelector = (memberships: CompanyMembership[], sections: CompanyMembershipSection[]) => {
  const membersMap: { [key: string]: CompanyMembership[] | undefined } = {};
  const restMembers: CompanyMembership[] = [];
  memberships.sort((a, b) => a.display_order - b.display_order).forEach(mem => {
    if (mem.section && mem.section.id) {
      membersMap[mem.section.id] = membersMap[mem.section.id] || [];
      membersMap[mem.section.id]!.push(mem);
    } else {
      restMembers.push(mem);
    }
  });
  const res: DenormalizedSection[] = [];
  sections.sort((a, b) => a.display_order - b.display_order).forEach(section => {
    res.push({
      section,
      memberships: membersMap[section.id] || [],
    });
  });
  res.push({
    section: undefined,
    memberships: restMembers,
  });
  return res;
};

export const featuredMembershipsSelector = (memberships: FeaturedCompanymembership[]) => {
  return memberships
    .filter(mem => mem.featured_display_order >= 0)
    .sort((a, b) => a.featured_display_order - b.featured_display_order);
};

export const draftFeaturedMembershipsSelector = (state: RootState) => state.companies.members.draftFeaturedMemberships;

export const postsSelector = (state: RootState) => state.companies.posts.posts;

export const featuredPostsSelector = (state: RootState) => state.companies.posts.featuredPosts;

export const pinnablePostsSelector = (state: RootState) => state.companies.posts.pinnablePosts;

export const spacesSelector = (state: RootState) => state.companies.posts.spaces;

export const featuredProjectsSelector = (state: RootState) => state.companies.show.projects;

export const projectsSelector = (state: RootState) => state.companies.projects.projects;

export const portfolioProjectsSelector = (state: RootState) => state.companies.show.portfolioProjects;

export const similarCompaniesSelector = (state: RootState) => state.companies.common.similarCompanies.slice(0, 5);

export const draftCompanyValuesSelector = (state: RootState) => state.companies.show.draftCompanyValues;

export const visibleCompanyValuesSelector = createSelector(draftCompanyValuesSelector, values =>
  values.filter(val => val.rank >= 0).sort((a, b) => a.rank - b.rank)
);

export const isDirtySelector = createSelector(
  (state: RootState) => state.companies,
  companies =>
    companies.common.isDraftCompanyDirty ||
    companies.show.isDraftCompanyValuesDirty ||
    companies.members.isDraftMembershipsDirty ||
    companies.posts.isDraftPostPinsDirty
);



// WEBPACK FOOTER //
// ./frontend/src/companies/selectors/index.ts